import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="py-10 md:py-24 px-4 bg-white" data-id="element-134">
      <div className="max-w-6xl mx-auto" data-id="element-135">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-136">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/9Rk3U6Q6EVcVacznEHzsvj/hf_20260319_213443_5757e727-d645-406a-9881-ec848675ca18.jpg" alt="El Protocolo de la Mañana en múltiples dispositivos" className="w-full h-auto rounded-xl shadow-xl" data-id="element-138" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2 space-y-6" data-id="element-139">
            <h2 className="text-3xl md:text-4xl font-bold text-teal-dark mb-6" data-id="element-140">
              La buena noticia es que el problema no es tu falta de fe.
            </h2>

            <p className="text-lg text-charcoal/80" data-id="element-141">
              El problema es que estás tratando de pelear una batalla del siglo
              XXI con herramientas del siglo pasado. La "Vida Eterna" no es algo
              que sucede cuando morimos; es una{' '}
              <span className="font-bold text-teal" data-id="element-142">
                realidad legal que puedes activar hoy mismo
              </span>
              .
            </p>

            <p className="text-lg text-charcoal/80" data-id="element-143">
              He descubierto que no necesitas tres horas de rodillas para ver
              milagros. Necesitas un{' '}
              <strong className="text-gold-light" data-id="element-144">
                Protocolo de Conexión Intencional
              </strong>
              .
            </p>

            <div className="bg-cream p-6 rounded-lg border-l-4 border-gold mt-6" data-id="element-145">
              <p className="text-lg font-medium text-teal-dark italic" data-id="element-146">
                Una forma de "hackear" tu mañana para que, en solo 10 minutos,
                tu espíritu se alinee con el trono de Dios y camines el resto
                del día con una armadura que nada puede penetrar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}